import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
    selector: "[onlyNumber]"
})

export class OnlyNumberDirective {
    constructor(private el: ElementRef){}

    @HostListener("keydown", ["$event"])
    onKeyDown(e: KeyboardEvent){
        this.onInputControl(e);
    }

    onInputControl(e:any){
        if(
            [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
            (e.keyCode === 65 && e.ctrlKey === true) || // Allow: Ctrl+A
            (e.keyCode === 67 && e.ctrlKey === true) || // Allow: Ctrl+C
            (e.keyCode === 88 && e.ctrlKey === true) || // Allow: Ctrl+X
            (e.keyCode === 65 && e.metaKey === true) || // Cmd+A (Mac)
            (e.keyCode === 67 && e.metaKey === true) || // Cmd+C (Mac)
            (e.keyCode === 88 && e.metaKey === true) || // Cmd+X (Mac)
            (e.keyCode >= 35 && e.keyCode <= 40) // Home, End, Left, Right
        ){
            return;
        }
        if (
            (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
            (e.keyCode < 96 || e.keyCode > 105)
        ) {
            // to do added bootstrap alert
            e.preventDefault();
        }
    }

    showAlert(){

    }
}